<template>
    <v-dialog :value="mostrarModalAssinarDocumentos" persistent :max-width="500">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                Assinar Documento{{ multiplo ? 's' : '' }}
            </v-card-title>
            <v-card-text class="pb-0 az-form-content">
                <p v-if="multiplo" class="font-weight-bold grey--text text--darken-2">Deseja realmente assinar os
                    documentos selecionados?</p>
                <p v-if="!multiplo" class="font-weight-bold grey--text text--darken-2">Deseja realmente assinar o
                    documento selecionado?</p>
                <v-card-text class="pt-1">
                    <div class="az-text">
                        <label class="label-size">Nome</label>
                        <p>{{ fornecedor.nomeUsuario }}</p>
                    </div>
                    <div class="az-text">
                        <label class="label-size">CPF</label>
                        <p>{{ fornecedor.cpfUsuario | azCpfCnpj }}</p>
                    </div>
                    <v-list v-if="multiplo" dense class="pa-0">
                        <div class="az-text">
                            <label class="label-size">Documento(s) selecionado(s):</label>
                        </div>
                        <v-list-tile v-for="documento in documentosSelecionados" :key="documento.id" dense class="pa-0">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ documento.descricao }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                    <div v-if="!multiplo">
                        <div class="az-text">
                            <label class="label-size">Documento selecionado:</label>
                        </div>
                        <span class="espacamento-documento-selecionado">{{ documentoSelecionado.descricao }}</span>
                    </div>
                </v-card-text>
            </v-card-text>
            <v-card-actions class="acoes justify-center">
                <v-btn color="#777" flat @click="fecharModal">
                    Fechar
                </v-btn>
                <v-btn class="botao-primario confirmar" flat @click="confirmarAcao">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalAssinarDocumentos',
    props: {
        mostrarModalAssinarDocumentos: {
            type: Boolean
        },
        multiplo: {
            type: Boolean
        },
        fornecedor: {
            type: Object,
            default: () => ({})
        },
        documentosSelecionados: {
            type: Array,
            default: () => []
        },
        documentoSelecionado: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fechar')
        },
        async confirmarAcao() {
            this.$emit('confirmar')
        }
    }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
    color #3A6861
    font-weight 600

.box-modal-confirm
    display flex
    flex-direction column
    justify-content center
    align-items center
    min-height 100px

.botao-primario
    padding 0 25px
    border 1px solid #7aa329
    background-color #7aa329 !important
    color #fff !important
    box-sizing border-box
    margin-left 15px !important

.acoes
    padding 20px 0 !important

.espacamento-documento-selecionado
    padding 0 16px

.label-size
    font-size: 14px !important

</style>